import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { Lang } from 'cat-shared/utils'

import commonDict from 'client/dictionary/common'
import apiMsgsDict from 'client/dictionary/apiMsgs'
import apiValidationErrors from 'client/dictionary/apiValidationErrors'

// page dictionaries
import rootPageDict from './pages/root-page.dict'
import authPageDict from './pages/auth-page.dict'
import homePageDict from './pages/home-page.dict'
import randomQuestionPageDict from './pages/random-question-page.dict'
import browseQuestionsPageDict from './pages/browse-questions-page.dict'
import createQuestionPageDict from './pages/create-question-page.dict'
import profilePageDict from './pages/profile-page.dict'
import settingsPageDict from './pages/settings-page.dict'
import aboutPageDict from './pages/about-page.dict'
import bestOfTheBestPageDict from './pages/best-of-the-best-page.dict'

// component dictionaries
import appDict from './components/app.dict'
import formsDict from './components/forms.dict'
import questionDict from './components/question.dict'

const resources = {
  [Lang.EN]: {
    translation: {
      common: commonDict[Lang.EN],
      apiMsgs: apiMsgsDict[Lang.EN],
      apiValidationErrors: apiValidationErrors[Lang.EN],
      // pages
      rootPage: rootPageDict[Lang.EN],
      authPage: authPageDict[Lang.EN],
      homePage: homePageDict[Lang.EN],
      randomQuestionPage: randomQuestionPageDict[Lang.EN],
      browseQuestionsPage: browseQuestionsPageDict[Lang.EN],
      createQuestionPage: createQuestionPageDict[Lang.EN],
      profilePage: profilePageDict[Lang.EN],
      settingsPage: settingsPageDict[Lang.EN],
      aboutPage: aboutPageDict[Lang.EN],
      bestOfTheBestPage: bestOfTheBestPageDict[Lang.EN],
      // components
      app: appDict[Lang.EN],
      forms: formsDict[Lang.EN],
      question: questionDict[Lang.EN],
    },
  },
}

i18next.use(initReactI18next).init({
  resources,
  lng: Lang.EN,
  interpolation: {
    escapeValue: false,
  },
})

export default i18next
